var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUserCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.5C7.233 21.5.093 27.38.093 34.625c0 .49.385.875.875.875h30.064c.49 0 .875-.385.875-.875C31.907 27.38 24.767 21.5 16 21.5zM16 .5a8.678 8.678 0 0 0-5.46 1.925A8.674 8.674 0 0 0 7.25 9.25c0 1.645.455 3.185 1.277 4.498A8.66 8.66 0 0 0 16 18a8.557 8.557 0 0 0 5.758-2.188 7.89 7.89 0 0 0 1.732-2.064 8.568 8.568 0 0 0 1.26-4.498C24.75 4.42 20.83.5 16 .5zm4.532 7.805L15.86 12.61a1.617 1.617 0 0 1-1.12.438c-.42 0-.84-.158-1.155-.473l-2.153-2.17a1.637 1.637 0 0 1 0-2.327 1.637 1.637 0 0 1 2.328 0l1.033 1.032 3.517-3.237a1.633 1.633 0 0 1 2.31.087c.613.683.578 1.732-.088 2.345z",
    fill: "#0044EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserCheck);
export default __webpack_public_path__ + "static/media/icon_user_check.c8704cbb25cdf608d6b07bafbcbf5011.svg";
export { ForwardRef as ReactComponent };